import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted as vueOnMounted} from 'vue';
import tenantModule from '@/store/modules/tenantModule';
import SockJS from 'sockjs-client';
import Stomp from 'webstomp-client';
import { NotificationMessage } from '../store/models';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServerNotification',
  emits: ['on-notification'],
  setup(__props, { emit: __emit }) {

const onMounted = vueOnMounted;

const socket = ref<any>(null);
const stompClient = ref<any>(null);
const subscription = ref<any>(null);

const emit = __emit;

onMounted(async () => {
  const tenant = tenantModule.tenantInfo || null;
  if (!tenant) {
    await tenantModule.loadTenantInfo();
  }
  if (tenantModule.tenantInfo) {
    connect(tenantModule.tenantInfo.identifier);
  }
});

const connect = (identifier: string) => {
  try {
    socket.value = new SockJS('/notification');

    stompClient.value = Stomp.over(socket.value, {
        debug: false,
        protocols: ['v12.stomp']
      });

    stompClient.value.reconnect_delay = 10000;

    stompClient.value.connect(
        {},
        (frame: any) => {
          subscription.value = stompClient.value.subscribe(
            '/notifychannel/' + identifier + '-notification',
            (tick: any) => {
              onMessageReceived(tick);
            }
          );
        },
        (error: any) => {
          console.log('error while connecting to socket');
        }
      );
  } catch (err) {
    console.log(err);
  }
};

const cleanUp = () => {
  try {
    if (subscription.value) {
      subscription.value.unsubscribe();
      disconnect();
      socket.value = null;
    }
  } catch (err) {
    console.log(err);
  }
};


  const disconnect = () => {
  if (stompClient.value) {
    stompClient.value.disconnect();
  }
};

 const onMessageReceived = (payload: any): any => {
  if (payload && payload.body) {
    sendMessage('Received payload inform server for testing');
    emit('on-notification', payload.body);
  }
  return {};
};

  const sendMessage = (msg: string) => {
  if (tenantModule.tenantInfo) {
    const queueId = tenantModule.tenantInfo.identifier + '-notification';
    const sendMsgObj = {
      queueId: queueId,
      message: msg,
      userId: 'recruiter',
      id: '' + new Date().getTime()
    };
    stompClient.value.send(
      '/app/pitchyou/' + queueId + '/message',
      JSON.stringify(sendMsgObj),
      {}
    );
  }
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div"))
}
}

})